import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CoachmarkTour } from '@models/coachmark.class';
import { TourService } from 'ngx-ui-tour-ngx-bootstrap';
import { Subscription } from 'rxjs';
import { TRACKING_EVENTS } from 'src/app';
import { MixpanelService } from 'src/core/services/mixpanel.service';
import { CoachmarkService } from './coachmark.service';

@Component({
  selector: 'hb-coachmark-component',
  templateUrl: './coachmark.component.html',
  styleUrls: ['./coachmark.component.scss'],
})
export class CoachmarkComponent implements OnInit, OnDestroy {
  @Input() public theme?: 'light' | 'dark' = 'dark';

  @Output() public onClose: EventEmitter<any> = new EventEmitter();

  public isVisible = false;

  public isSecuenceButtons = false;

  public stepsLength: number;

  public activeTour: CoachmarkTour;

  private steps: any[];
  public currentStep: number;

  private subscription = new Subscription();

  constructor(
    private readonly tourService: TourService,
    private readonly coachmarkService: CoachmarkService,
    private readonly mixpanelService: MixpanelService,
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.coachmarkService.startTour$.subscribe((tour) => {
        if (
          this.activeTour &&
          this.activeTour.mainAnchorId === tour.mainAnchorId
        ) {
          return;
        }

        this.coachmarkService.endTour();

        this.activeTour = tour;
        this.tourService.initialize(tour.steps, {
          // preventScrolling: true,
        });

        this.coachmarkService.startTour();
      }),
    );

    this.subscription.add(
      this.tourService.initialize$.subscribe(() => {
        this.steps = this.tourService.steps;
        this.stepsLength = this.steps.length;
        this.currentStep = 1;
        this.isSecuenceButtons = this.stepsLength && this.stepsLength > 1;
      }),
    );

    this.subscription.add(
      this.coachmarkService.startTourSubject.subscribe(() => {
        this.isVisible = true;
        this.tourService.start();
      }),
    );

    this.subscription.add(
      this.coachmarkService.endTourSubject.subscribe(() => {
        this.tourService.end();
        this.isVisible = false;
        this.activeTour = undefined;
      }),
    );

    this.subscription.add(
      this.tourService.anchorUnregister$.subscribe((e) =>
        this.coachmarkService.removeTourFromList(e),
      ),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public endTour(): void {
    this.mixpanelService.track(TRACKING_EVENTS.coachmark.event, {
      name: this.activeTour.eventAnchorId,
      step:
        this.currentStep !== this.stepsLength ? this.currentStep : 'COMPLETE',
    });

    this.coachmarkService.updateCoachmarkTour(this.activeTour);
    this.tourService.end();
  }

  public nextStep(): void {
    this.currentStep++;
    this.tourService.next();
  }

  public prevStep(): void {
    this.currentStep--;
    this.tourService.prev();
  }
}
